import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';

import * as Objects from '@core/objects';

import * as Models from '@app/models/ai.model';
import * as fromState from '@app/store/state/ai/ai.state';
import * as fromActions from '@app/store/state/ai/ai.actions';


@Injectable({
  providedIn: 'root',
})
export class AIService {

  constructor(private store: Store<fromState.AIState>) { }

  // Dispatch actions to start the AI
  warmUp(): void {
    this.store.dispatch(fromActions.WarmUp());
  }

  // Dispatch actions to send a new question
  sendQuestion(question: string): void {
    this.store.dispatch(fromActions.SendQuestion({ question }));
  }

  // Selectors to retrieve data from the state
  getAllEntries(): Observable<fromState.AIEntry[]> {
    return this.store.select(fromState.selectAllEntries);
  }

  getQuestions(): Observable<Models.AIQuestionModel[]> {
    return this.store.select(fromState.selectQuestions);
  }

  getAnswers(): Observable<Models.AIAnswerModel[]> {
    return this.store.select(fromState.selectAnswers);
  }

  getLoadingStatus(): Observable<boolean> {
    return this.store.select(fromState.selectLoadingStatus);
  }

  getInitializedStatus(): Observable<boolean> {
    return this.store.select(fromState.selectInitializedStatus);
  }

  getWarmUpError(): Observable<HttpErrorResponse> {
    return this.store.select(fromState.selectWarmUpError);
  }

  getQuestionError(): Observable<HttpErrorResponse> {
    return this.store.select(fromState.selectQuestionError);
  }

  getAnswerError(): Observable<HttpErrorResponse> {
    return this.store.select(fromState.selectAnswerError);
  }

}
